<script setup>
const { countdownTransform, countdownTransformDaysToHours } = useHelpers()

const props = defineProps({
  remaining: {
    type: Number,
    default: 0
  },
  daysToHours: {
    type: Boolean,
    default: false
  },
  boxClass: {
    type: String,
    default: ''
  },
  boxStyle: {
    type: String,
    default: ''
  }
})

function transform (params) {
  return props.remaining <= 48 * 60 * 60 * 1000 || props.daysToHours
    ? countdownTransformDaysToHours(params)
    : countdownTransform(params)
}
</script>

<template>
  <ClientOnly>
    <VueCountdown
      v-if="remaining > 0"
      v-slot="data"
      :time="remaining"
      :transform="transform">
      <div
        class="flex w-fit items-center justify-center rounded  text-[10px] font-extrabold tracking-wider  md:text-[10px] xl:text-sm"
        :class="[boxClass, daysToHours ? 'w-[65px] md:w-[104px] xl:w-[130px]': 'w-[65px] md:w-[104px] xl:w-[130px]' ]"
        :style="boxStyle">
        <div
          v-for="(part, index) in data.days && data.days !== '00' ? ['days', 'hours', 'minutes'] : ['hours', 'minutes', 'seconds']"
          :key="part"
          class="flex items-center">
          {{ data[part] }}{{ part.charAt(0) }}
          <span v-if="index < 2">
            :
          </span>
        </div>
      </div>
    </VueCountdown>
  </ClientOnly>
</template>
